var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/brand/brand-header-large.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"brandNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"));
frame.set("categoryBrand", t_1, true);
if(frame.topLevel) {
context.setVariable("categoryBrand", t_1);
}
if(frame.topLevel) {
context.addExport("categoryBrand", t_1);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "categoryBrand") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryBrand")),"displayName")) {
output += "\n\n    ";
var t_2;
t_2 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryBrand")),"displayName");
frame.set("brandName", t_2, true);
if(frame.topLevel) {
context.setVariable("brandName", t_2);
}
if(frame.topLevel) {
context.addExport("brandName", t_2);
}
output += "\n    ";
var t_3;
t_3 = "category_brand-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryBrand")),"slug") + "" + "-seo-copy";
frame.set("brandSeoSlug", t_3, true);
if(frame.topLevel) {
context.setVariable("brandSeoSlug", t_3);
}
if(frame.topLevel) {
context.addExport("brandSeoSlug", t_3);
}
output += "\n    ";
var t_4;
t_4 = "category_brand-default-seo-copy";
frame.set("brandSeoSlugDefault", t_4, true);
if(frame.topLevel) {
context.setVariable("brandSeoSlugDefault", t_4);
}
if(frame.topLevel) {
context.addExport("brandSeoSlugDefault", t_4);
}
output += "\n    ";
var t_5;
t_5 = (lineno = 9, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "brandSeoSlug"),runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryBrand")),"displayName"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"siteName")],"defaultSlug": runtime.contextOrFrameLookup(context, frame, "brandSeoSlugDefault")})]));
frame.set("brandSeoText", t_5, true);
if(frame.topLevel) {
context.setVariable("brandSeoText", t_5);
}
if(frame.topLevel) {
context.addExport("brandSeoText", t_5);
}
output += "<div class=\"o-row o-column o-extra-small--12\">\n\n    <div class=\"o-row\">\n\n        <div class=\"g-brand-header__outer\">\n\n            <div class=\"c-brand-header\">\n\n                <div class=\"g-brand-header c-brand-header__inner\">\n\n                    <h2 class=\"c-brand-header__h1\" data-qa-brand-title>\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "brandName"), env.opts.autoescape);
output += "\n                    </h2>\n\n                    ";
if(!runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "brandSeoText"),["{" + "" + runtime.contextOrFrameLookup(context, frame, "brandSeoSlug") + "" + "}","{" + "" + runtime.contextOrFrameLookup(context, frame, "brandSeoSlugDefault") + "" + "}",""])) {
output += "\n                        <p class=\"c-brand-header__p\" data-qa-brand-copy>\n                            ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "brandSeoText"), env.opts.autoescape);
output += "\n                        </p>\n                    ";
;
}
output += "</div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/brand/brand-header-large.j2"] , dependencies)